import {extendObservable} from 'mobx';


/**
 * UserStore
 */
class UserStore{
  constructor(){
    extendObservable(this,{
      loading: true,
      isLoggedIn:false,
      username: '',
      access_token: '',
      refresh_token: '',
      roles: [],
      picture: '/global_assets/images/image.png',
      services:[]
    })
  }
}

export default new UserStore();
